import { PickerOptionsSection } from '../store/schema/CompositePickerInterfaces';
import CompositePickerStore from '../store/schema/CompositePickerStore';

export default function getCompositePickerOptionsForAccount(
    viewState: CompositePickerStore,
    account: string
): PickerOptionsSection {
    const allOptions = viewState.options;

    if (allOptions.length > 0) {
        const optionsForAccount = allOptions.filter(option => option && option.account == account);

        if (optionsForAccount.length === 1) {
            return optionsForAccount[0];
        }
    }

    return null;
}
